<script lang="ts">
import { defineComponent } from 'vue';
import { Tooltip } from 'ant-design-vue';
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons-vue';
import { any, bool, string } from 'vue-types';
import type { TooltipPlacement } from 'ant-design-vue/lib/tooltip/Tooltip';

export default defineComponent({
  name: 'ActiveInactiveIcon',
  components: {
    Tooltip,
    CheckCircleOutlined,
    WarningOutlined,
  },
  props: {
    class: any(),
    activeClass: string().def('text-green-600'),
    inactiveClass: string().def('text-yellow-600'),
    status: bool().isRequired,
    active: string().def('Active'),
    inactive: string().def('Inactive'),
    text: string(),
    placement: string<TooltipPlacement>(),
  },
  methods: {
    hasTitleSlot() {
      return !!this.$slots.title;
    },
  },
});
</script>
<template>
  <div :class="$props.class">
    <div
      :class="{
        [activeClass]: status,
        [inactiveClass]: !status,
      }"
    >
      <Tooltip :placement="placement">
        <template #title>
          <slot v-if="hasTitleSlot()" name="title" />
          <div v-else>
            <span v-if="status">{{ active }}</span>
            <span v-else>{{ inactive }}</span>
          </div>
        </template>
        <CheckCircleOutlined v-if="status" />
        <WarningOutlined v-else />
      </Tooltip>
    </div>
    <span v-if="text">
      {{ text }}
    </span>
  </div>
</template>
